import React from 'react'
import AdmIssueDamagedReport from '../../components/AdminTabs/AdminIssueDamagedReport/AdmIssueDamagedReport'

const IssueDamagedReport = () => {
  return (
    <div>
      <AdmIssueDamagedReport/>
    </div>
  )
}

export default IssueDamagedReport
